import Alpine from "alpinejs";
import bookingForm from "./booking-form.js";
import priceCalculator from "./price-calculator.js";

window.Alpine = Alpine;
Alpine.data("bookingForm", bookingForm);
Alpine.data("priceCalculator", priceCalculator);
Alpine.data("heroVideoPlayer", () => ({
    isPlaying: false,
    isMuted: false,
    progress: 0,
    togglePlay() {
        const video = this.$refs.video;
        if (!video) {
            return;
        }

        if (video.paused) {
            this._loadIfNeeded(video);
            video.play();
            this.isPlaying = true;
            return;
        }

        video.pause();
        this.isPlaying = false;
    },
    _loadIfNeeded(video) {
        const source = video.querySelector("source[data-src]");
        if (!source) {
            return;
        }

        source.src = source.dataset.src;
        delete source.dataset.src;
        video.load();
    },
    toggleMute() {
        const video = this.$refs.video;
        if (!video) {
            return;
        }

        video.muted = !video.muted;
        this.isMuted = video.muted;
    },
    onLoadedMetadata() {
        const video = this.$refs.video;
        if (!video) {
            return;
        }

        this.isMuted = video.muted;
    },
    onTimeUpdate() {
        const video = this.$refs.video;
        if (!video || !video.duration) {
            return;
        }

        this.progress = (video.currentTime / video.duration) * 100;
    },
    seek() {
        const video = this.$refs.video;
        if (!video || !video.duration) {
            return;
        }

        video.currentTime = (this.progress / 100) * video.duration;
    },
}));
Alpine.start();

// mapbox-gl is large, so only load it on pages that render a map.
window.loadMapbox = () => import("./mapbox.js").then((m) => m.default);
